import React from "react";

export default function InfoCircleIcon()
{
  return (


    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.9999 5.33317C15.6666 5.33317 18.6666 8.33317 18.6666 11.9998C18.6666 15.6665 15.6666 18.6665 11.9999 18.6665C8.33325 18.6665 5.33325 15.6665 5.33325 11.9998C5.33325 8.33317 8.33325 5.33317 11.9999 5.33317Z" stroke="var(--color-icon-btn-action-header-drawer)" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M12 14.6665V11.3332" stroke="var(--color-icon-btn-action-header-drawer)" stroke-linecap="round" stroke-linejoin="round" />
      <path d="M11.9963 9.3335H12.0023" stroke="var(--color-icon-btn-action-header-drawer)" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  );
}
